<template>
  <div class="FeedMenu">
    <ul
      v-for="section in sections"
      :key="section.key"
    >
      <li class="feed-menu-heading">
        <span>{{ $t(section.title) }}</span>
        <router-link
          v-if="section.manage"
          :to="section.manage"
        >
          {{ $t('nav.manage') }}
        </router-link>
      </li>
      <NavigationEntry
        v-for="item in section.items"
        :key="item.name"
        :item="item"
      />
    </ul>
    <ul
      v-if="settings"
      class="feed-menu-settings"
    >
      <li class="menu-item">
        <TimelineSettingsMenu labelled />
      </li>
    </ul>
  </div>
</template>

<script src="./feed_menu.js"></script>

<style lang="scss">
.FeedMenu {
  ul {
    list-style: none;
    margin: 0;
    padding: 0.25em;
  }

  ul + ul {
    padding-top: 0;
  }

  .feed-menu-heading {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 0.5em 0.75em 0.15em;
    font-size: var(--fs-sm);
    color: var(--textFaint);
  }

  .menu-item {
    border-radius: var(--r-item);
  }

  /* laid out like the NavigationEntry rows above it */
  .feed-menu-settings {
    border-top: 1px solid var(--border);

    .popover-wrapper,
    .popover-trigger-button {
      display: flex;
      align-items: center;
      width: 100%;
    }

    .popover-trigger-button {
      padding: 0.4em 0.5em;
      line-height: 2.5em;
      text-align: start;
    }

    .menu-icon {
      width: 2.5em;
      margin-right: 0.5em;
    }
  }
}
</style>
